import React, { useState } from 'react';
import Modal from 'react-modal';
const customStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000,
    },
    content: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: '400px',
      width: '90%',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      backgroundColor: '#ffffff',
      textAlign: 'center', // Center-align content
    },
    closeButton: {
      position: 'absolute',
      top: '10px',
      right: '10px', // Right-align close button
      cursor: 'pointer',
      border: 'none',
      background: 'transparent',
      fontSize: '24px',
    },
  };
  

const Popup = ({ isOpen, closeModal,url }) => {
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleConfirm = () => {    
    // Close the modal
    closeModal();
    const newTab = window.open(url, '_blank');
    const checkClosed = setInterval(() => {
        if (newTab.closed) {
            clearInterval(checkClosed);
            // The user has closed the new tab, you can perform further actions here
        }
    }, 1000);

    return () => {
        clearInterval(checkClosed);
    };
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal" className="PetInput"
    >
      {/* <button className="close-button" onClick={closeModal}>
        &times;
      </button> */}
      <h2>CKYC Confirmation</h2>
      <p>Based on your entered details you CKYC details are not found.
        please click on below link to complete your ckyc and then try again.
      </p>     
      <button className="SMCBTN w-auto"  onClick={handleConfirm}>Click Me</button>
    </Modal>
  );
};

export default Popup;
